import { ReactNode } from 'react';
import { SettingsMenuContextProvider } from './SettingsMenuContext';
import { AppsMenuContextProvider } from './AppsMenuContext';
import { AiContextProvider } from './AiContext';
import { TutorialsContextProvider } from './TutorialsContext';
interface AppContextsProps {
  children: ReactNode;
}

export const AppContexts = ({ children }: AppContextsProps) => {
  return (
    <TutorialsContextProvider>
      <SettingsMenuContextProvider>
        <AppsMenuContextProvider>
          <AiContextProvider>{children}</AiContextProvider>
        </AppsMenuContextProvider>
      </SettingsMenuContextProvider>
    </TutorialsContextProvider>
  );
};
